<template>
    <div class="mortem container-fluid p-0" style="overflow: hidden;">
        <router-view @childrenRoute="hideNonChildren" />
        <div class="row" v-if="!isChildRoute">
            <div class="col-md-12">
                <Report v-if="false" />
                <Overview v-if="false" />
                <Slide />
            </div>
        </div>
    </div>
</template>

<script>
import Customer from "@/components/page/Customer.js";
import BarCard from "@/views/pages/BarCard.vue";
import ListItem from "@/views/pages/ListItem2.vue";
import ListCompare from "@/views/pages/ListCompare.vue";
import ListItemPiutangByAging from "@/views/pages/ListItemPiutangByAging.vue";
import Footer from "@/views/Footer.vue";
import Report from "@/views/pages/PostMortem/PostMortemReport.vue";
import Overview from "@/views/pages/PostMortem/Performance/Overview.vue";
import Slide from "@/views/pages/PostMortem/PostMortemSlide.vue";

import {
    Rainbow,
    FuelColor,
    Config,
    Penanggalan,
    AxiosWithJar,
} from "@/utility.js";

export default {
    extends: Customer,
    components: {
        Report,
        Overview,
        Slide,
        //Footer,
        //ListItem,
        //ListItemPiutangByAging,
    },
    mounted() {
        this.$emit("childrenRoute");
        this.hideNonChildren();
        //this.loadTop();
        //this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
        //document.title=this.$store.state.page+' - Dashboard'
        //this.getData()
    },
    data() {
        return {
            isChildRoute: false,
        };
    },
    watch: {},
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== "/post-mortem";
            //this.isChildRoute = this.$route.path !== '/post-mortem/performance';
        },
        getData() {
            this.urlRequestParams = Config().apiURL;
            this.urlRequestParams += "/customer/top-piutang?";

            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

            this.loading.table = true;
            AxiosWithJar()
                .get(this.urlRequestParams)
                .then((response) => {
                    this.reportdata = response.data;
                    //console.log('data: ' + JSON.stringify(this.reportData))
                })
                .catch((error) => {
                    console.log(error);
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.table = false;
                });
        },

    },
};
</script>
